export default __webpack_public_path__ + "static/thumb-17-ded3218cd27ddd1c0c071b293d13cc4c.jpg";